// extracted by mini-css-extract-plugin
module.exports = {"spinner":"spinner_spinner__5qgOs","doubleBounce1":"spinner_doubleBounce1__1mEXh","doubleBounce2":"spinner_doubleBounce2__1JaVL","skBounce":"spinner_skBounce__3XoSX"};
    if(module.hot) {
      // 1785568527824
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  